/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon32Regular = forwardRef('LogoMicrosoftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 6.5A3.5 3.5 0 0 1 6.5 3h19A3.5 3.5 0 0 1 29 6.5v19a3.5 3.5 0 0 1-3.5 3.5h-19A3.5 3.5 0 0 1 3 25.5v-19ZM5 17v8.5A1.5 1.5 0 0 0 6.5 27H15V17H5Zm10-2H5V6.5A1.5 1.5 0 0 1 6.5 5H15v10Zm2 2v10h8.5a1.5 1.5 0 0 0 1.5-1.5V17H17Zm10-2H17V5h8.5A1.5 1.5 0 0 1 27 6.5V15Z" })));
});
